import styled from "styled-components";

const TitleStyle = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'BrighterPKlgg';
  color: #f5f0e5;
  width: 50%;
`

function Title(props) {
    return (
      <TitleStyle>
          <h1>{props.text}</h1>
      </TitleStyle>
    );
  }
  
  export default Title;